import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
  padding: ${props => `${props.theme.whiteLabel.spacing.sp24} 0px`};
`

export const Title = styled(Text)`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
`

export const NumberOfReturnLabelsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`

export const SelectorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.theme.colors.grey.tone50};
  border-radius: 8px;
  padding: ${props => `${props.theme.whiteLabel.spacing.sp8} ${props.theme.whiteLabel.spacing.sp16}`};
`

export const SelectorButtons = styled.div`
  display: flex;
  gap: ${props => props.theme.whiteLabel.spacing.sp32};
`
